import { FigureTwicpics } from '@studiometa/ui';
import { isProd } from '../../config.js';

/**
 * Class.
 */
export default class Figure extends FigureTwicpics {
  /**
   * Domain.
   * @returns {string}
   */
  get domain() {
    return 'champagne.twic.pics';
  }

  /**
   * No path in production, use the hostname otherwise.
   * @returns {string}
   */
  get path() {
    return isProd ? '' : window.location.hostname;
  }
}
